import naja from "naja";

class PasswordHelper {
    constructor() {
        this.init();
    }

    init() {
        window.addEventListener('DOMContentLoaded', () => this.bindEvents());
        naja.snippetHandler.addEventListener('afterUpdate', () => this.bindEvents());
    }

    bindEvents() {
        const self = this;

        // Odebere chybové zprávy LFV (_message) u tlačítek
        $('.form-group-password .input-group button + span[id^="_message"]').remove();

        $(document).off('click', '.toggle-password').on('click', '.toggle-password', function() {
            const input = $(this).closest('.input-group').find('input');
            const icon = $(this).find('i');

            if (input.attr('type') === 'password') {
                input.attr('type', 'text');
                icon.removeClass('bi-eye').addClass('bi-eye-slash');
            } else {
                input.attr('type', 'password');
                icon.removeClass('bi-eye-slash').addClass('bi-eye');
            }
        });

        $(document).off('click', '.generate-password').on('click', '.generate-password', function() {
            const input = $(this).closest('.input-group').find('input');
            const pass = self.generatePassword();
            input.val(pass);

            const display = $(this).closest('.form-group-password').find('.visible-pass-container');
            if (display.length) {
                display.html(`<span class="badge bg-success visible-pass" style="cursor: pointer; padding: 5px 10px;">${pass}</span>`);
            }
        });

        $(document).off('click', '.visible-pass').on('click', '.visible-pass', function() {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(this);
            selection.removeAllRanges();
            selection.addRange(range);
        });
    }

    generatePassword() {
        const length = 8;
        const charset = {
            upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            lower: "abcdefghijklmnopqrstuvwxyz",
            number: "0123456789",
            special: "."
        };

        let password = "";
        password += charset.upper.charAt(Math.floor(Math.random() * charset.upper.length));
        password += charset.lower.charAt(Math.floor(Math.random() * charset.lower.length));
        password += charset.number.charAt(Math.floor(Math.random() * charset.number.length));
        password += charset.special;

        const all = charset.upper + charset.lower + charset.number;
        for (let i = password.length; i < length; i++) {
            password += all.charAt(Math.floor(Math.random() * all.length));
        }

        return password.split('').sort(() => 0.5 - Math.random()).join('');
    }
}

new PasswordHelper();
